/***/

import axios from 'axios'
import store from '@/assets/js/store'
import router from './router'

router.afterEach((to, from, next) => {

   if(!to.path.includes("/channel/") || to.path.includes("/channel/list")){
    setTimeout(
      ()=>{ 
      ga('set', 'page', to.path)
      ga('send', 'pageview')},1000);
  }
  // else{
  //   ga('set', 'page', to.path)
  //   ga('send', 'pageview')
  //  }


 
  if (to.meta.breadcrumb ){
     store.commit('currentBreadcrumb', to.meta.breadcrumb)
  }
 
  if (window.scrollY > 0 ) {

    $('html,body').animate({
      scrollTop: 0
    }, 'slow');

}
});

// http request 拦截器

axios.interceptors.request.use(function (config) {
 
 

  return config;

},
 function (error) {
  return Promise.reject(error);
});


// Add a request interceptor
axios.interceptors.response.use(
  response => {
    

      return response;
      
  },
  error => {

    if(error.includes("422")){
      store.commit('couponState', "輸入錯誤，請再確認您的優惠券序號")

    }

    else if(error.includes("410")){
      store.commit('couponState', "此優惠券已被使用，請確認您的序號")

    }
    else if(error.includes("404")){
      store.commit('couponState', "活動已結束，優惠券無法存入")

    }
    else if(error.includes("423")){
      store.commit('couponState', "活動已結束，優惠券無法存入")

    }

    if(error.includes("401")){
      alert("為保障您的帳戶安全，請您重新登入");
      localStorage.removeItem('user-info') 
        window.location.href =  "/index"
    }

    return error;

  });

export default axios;



// WEBPACK FOOTER //
// ./src/http.js